import React, { useCallback, useEffect, useRef, useState } from "react";
import Logo from "../components/Logo";
import CountdownTimer from "../components/Countdown";
import BgPattern from "../components/BgPattern";
import LoadingScreen from "../components/Loading";
import MessageSentPopup from "../components/messageSentPopup";
import { useLocation, useParams } from "react-router-dom";
import { postMessage } from "../service/db";

function AnonymousMessageScreen() {
	const [showLoading, setshowLoading] = useState(false);
	const [message, setMessage] = useState("");
	const [isLimitExceeded, setisLimitExceeded] = useState(true);
	const [showPopup, setShowPopup] = useState({
		show: false,
		isSuccess: false,
	});
	const wordLimit = 300;
	const pubid = useRef();
	const location = useLocation();

	useEffect(() => {
		const urlParams = new URLSearchParams(location.search);
		pubid.current = urlParams.get("pubid");
	}, []);


	const handlePostMessage = (event) => {
		// Validate and handle posting the anonymous message

		if (message.trim() !== "") {
			// Implement your logic to post the message
			// console.log(pubid.current , message)
			setshowLoading(true);
			postMessage(
				pubid.current,
				message,
				async (res) => {
					const { db_entry_status } = await res.json();
					setshowLoading(false);
					if (db_entry_status) {
						setShowPopup({
							show: true,
							isSuccess: true,
						});
						setMessage("");
					} else {
						setShowPopup({
							show: true,
							isSuccess: false,
						});
					}
				},
				(err) => {
					setshowLoading(false);
					setShowPopup({
						show: true,
						isSuccess: false,
					});
				}
			);
		} else {
			setshowLoading(false);
			setShowPopup({
				show: true,
				isSuccess: false,
			});
			// Provide feedback to the user about empty message
			console.error("Message cannot be empty");
		}
	}

	const handleChange = (event) => {
		const inputMessage = event.target.value;
		const words = inputMessage.trim().split(/\s*/);
		if (words.length > 0 && words.length <= wordLimit) {
			setisLimitExceeded(false);
			setMessage(inputMessage);
		} else {
			setisLimitExceeded(true);
			setMessage(inputMessage);
		}
	}

	return (
		<div className="bg-[#0b0022] font-custom relative h-full  w-full overflow-hidden text-white flex flex-col items-center justify-center">
			<BgPattern className="absolute top-0 left-0 w-full h-full opacity-30 "></BgPattern>
			<LoadingScreen show={showLoading} />
			<div className="z-10 bg-[rgba(53,51,77 , 0.5)]  flex flex-col  p-2  items-center md:w-[70%] lg:w-[50%] xl:w-[40%] rounded-md">
				<h1 className="text-[2rem] font-bold text-gray-100 ">TellMeBefore24</h1>
				<p className="text-md text-gray-200 text-center font-semibold mb-4">Let them know what you wanna tell before 2024</p>

				<textarea value={message} onChange={handleChange} className="p-4  bg-[#2f255b] rounded-md border-0 w-full   mb-4 resize-none h-[30vh] font-semibold outline-none" placeholder={`Type here...`} />
				<div className="flex justify-between w-full md:w-[70%] lg:w-[50%] xl:w-[40%] mb-4">
					<p className="text-sm text-gray-400">
						{message.trim().split(/\s*/).length}/{wordLimit}
					</p>
					{/* {isLimitExceeded && <p className="text-sm text-red-500">Exceeds limit!</p>} */}
				</div>
				<button disabled={isLimitExceeded} onClick={handlePostMessage} className={`bg-[${message.trim().split(/\s+/).length > wordLimit ? "gray-500" : "#6100FF"}] disabled:bg-gray-600 w-full md:w-[70%] lg:w-[50%] xl:w-[40%] rounded-md p-2 outline-none focus:border-pink-500 hover:bg-[#4c00cc] active:bg-[#2f1f54] text-white text-center text-sm sm:text-base`}>
					Send
				</button>
			</div>
			<Logo className="absolute bottom-0"></Logo>
			<MessageSentPopup isOpen={showPopup.show} isSuccess={showPopup.isSuccess} onClose={() => setShowPopup({ show: false, isSuccess: false })}></MessageSentPopup>
		</div>
	);
}

export default AnonymousMessageScreen;
